// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"a875b437","37":"6eee5023","66":"b26d7c0a","136":"dbef36bd","167":"f8db48da","171":"25fa06af","178":"485c283f","227":"68b02b31","312":"82b66df0","375":"f1f09e31","382":"87692a2c","453":"c37b6b9a","648":"5c8c26ba","715":"c784263a","945":"4ab81262","987":"85c5a017"}[chunkId] + ".chunk.js";
};